export const DEFAULT_PROFILE_TYPE = 'SavedSearch';

export const VISIBILITY_TYPES = {
  PRIVATE: 'private',
  COMPANY: 'company',
  PARTNERS: 'partners'
} as const;

export const TABLE_TYPES = {
  INVENTORY: 'inventory',
  ORDERS: 'orders',
  POC: 'poc',
  DOCUMENTS: 'documents',
  MESSAGE_CENTER: 'message_center',
  CATALOG: 'catalog',
  DASHBOARD: 'dashboard'
};

export const STORAGE_KEYS = {
  CACHE_PREFIX: 'savedSearch-cache-',
  DEFAULT_PREFIX: 'savedSearch-default-'
};

export const DEFAULT_CONFIG = {
  filters: {
    logic: 'and',
    filters: []
  },
  columns: {
    visible: [],
    hidden: [],
    order: []
  },
  sorting: {
    orderBy: null,
    order: 'asc'
  },
  pagination: {
    pageSize: 25
  },
  searchTerm: ''
};

export const MESSAGES = {
  DELETE_PRIVATE: 'Are you sure you want to delete this view? This action cannot be undone.',
  DELETE_COMPANY: 'Are you sure you want to delete this view? It will be removed for all users in your company. This action cannot be undone.',
  DELETE_PARTNERS: 'Are you sure you want to delete this view? If this is a shared view, it will also be removed for everyone it was shared with. This action cannot be undone.',
  SAVE_SUCCESS: 'Search saved successfully',
  DELETE_SUCCESS: 'Search deleted successfully',
  LOAD_ERROR: 'Failed to load saved searches',
  SAVE_ERROR: 'Failed to save search',
  DELETE_ERROR: 'Failed to delete search'
};